import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Config } from '@ionic/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent  {
  
  @Input() startDate:Date = new Date();
  @Input() toDate: string;
  @Input() dateFormat: 'date' | 'datetimestamp' = 'date';
  
  @Input() datePickerOptionsFromMin:string;
  @Input() datePickerOptionsFromMax: string;
  @Input() datePickerOptionsToMin: string;
  @Input() datePickerOptionsToMax: string;

  @Input() fromMaxBeforeCurrentDate:boolean = false;



  @Input() isMigratedPlayer:boolean;

  private _fromDate: string;
  migrationDate: Date;
  @Input() set fromDate(value: string) {
    if( value !== this._fromDate) {
      this._fromDate = value;
      if(this.dateRange && value) {
        this.disableSinceFrom();
        this.onDateChangedFromValue(value);
      }
    }
    else {
      this._fromDate = value;
    }
  }
  get fromDate(): string {
    return this._fromDate;
  }

  private _dateRange: number;
  @Input() set dateRange(value: number) {
    if( value !== this._dateRange) {
      this._dateRange = value;
      if(this.fromDate && value) {
        this.onDateChangedFromValue(this.fromDate);
      }
    }
    else {
      this._dateRange = value;
    }
  }
  get dateRange(): number {
    return this._dateRange;
  }

  @Output() calendarUpdate: any;  

  public searchDisabled = true;
  public jsDateObject: any;
  public useDateToAsFromMax:boolean = false; // true: use DateTo As FromMax, otherwise , use today

  constructor(
    private timeService: TimeService,
    private config:ConfigService,
    private authService:AuthenticationService
    ) {
      this.migrationDate = new Date(this.config.getConfig().FEATURE_MIGRATION_DATE || "04/23/2024");
      // this.isMigratedPlayer = this.authService.checkMigratedPlayer();
      this.calendarUpdate = new EventEmitter<any>();
      this.dateRange = this.dateRange || 14;
      this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(new Date(this.startDate.setDate(this.startDate.getDate() - this.dateRange))));

      // if(this.isMigratedPlayer){
      //   this.toDate = this.migrationDate.toISOString(); 
      // }else {
      //   this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(new Date()));
      // }


      
      this.disableSinceFrom();
      this.disableSinceTo();
      this.disableUntilTo();
     }
     

  disableSinceFrom() {
    let todayDate: Date = new Date();
    if(this.fromMaxBeforeCurrentDate) {
      todayDate.setDate(todayDate.getDate() -1);
    }
    const todayISOStr = todayDate.toISOString();
    const todayDateOnlyISOStr = todayISOStr.split('T')[0];
    const fromMax = this.useDateToAsFromMax ? this.toDate : todayDateOnlyISOStr;
   
    if(this.isMigratedPlayer){
      this.datePickerOptionsFromMax = (new Date(this.migrationDate.toISOString().split('T')[0])).toISOString();  
    }else {
      this.datePickerOptionsFromMax = todayDateOnlyISOStr >= fromMax ? fromMax : todayISOStr;

    }
  }
  
  disableSinceTo() {
    let d: Date = new Date(this.fromDate);
    if(!this.isMigratedPlayer){
      this.datePickerOptionsToMin = d.toISOString() >= this.fromDate ? this.fromDate : d.toISOString();
    }
  }

  disableUntilTo() {
    let d: Date = new Date(this.fromDate);

    if(!this.isMigratedPlayer){
      d.setDate(new Date(this.fromDate).getDate() + this.dateRange);
    }else {
      d = new Date(this.migrationDate.toISOString().split('T')[0]);  
    }
    
    this.datePickerOptionsToMax = new Date() >= d ? d.toISOString() : new Date().toISOString();

    
  }

  onDateChangedFrom(event: any) {
    this.onDateChangedFromValue(event.target.value);
    this.onCalendarUpdate();
  }


  onDateChangedFromValue(value: string) {
    this.fromDate = value.split('T')[0];
    this.jsDateObject = this.fromDate + 'T00:00:00';
    let toDateForward ;
    toDateForward = new Date(this.jsDateObject);
    toDateForward.setDate(toDateForward.getDate() + this.dateRange); //add 2 weeks to 'toDate' automatically when user picks a date
    if(!this.isMigratedPlayer){
      this.toDate = toDateForward <= new Date() ? toDateForward.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
    }else {
      this.toDate = toDateForward <= new Date(this.migrationDate.toISOString()) 
      ? toDateForward.toISOString() 
      : this.migrationDate.toISOString();
    }
    this.disableSinceTo();
    this.disableUntilToFromChanged();
  }
  disableUntilToFromChanged() {
    let d: Date = new Date(this.fromDate);
    d.setDate(new Date(this.fromDate).getDate() + this.dateRange);   
    if(!this.isMigratedPlayer){
      this.datePickerOptionsToMax = new Date() >= d ? d.toISOString() : new Date().toISOString();
    } else {
      this.datePickerOptionsToMax = new Date(this.migrationDate.toISOString().split('T')[0]) >= d ? d.toISOString() : this.migrationDate.toISOString();

    }

  }
  onDateChangedTo(event: any) {
    this.onDateChangedToValue(event.target.value);
    this.onCalendarUpdate();
  }

  onDateChangedToValue(value: string) {
    this.toDate = value.split('T')[0];
    if(this.useDateToAsFromMax) {
      this.disableSinceFrom();
    }
  }

  onCalendarUpdate() {
    this.calendarUpdate.emit({
      fromDate: this.fromDate,
      toDate: this.toDate,
      search: !this.searchDisabled
    });
  }
}
